import { createSlice } from "@reduxjs/toolkit";

export const abhaSlice = createSlice({
  name: "abha",
  initialState: {
    loading: false,
    gettime: [],
    getaccesstoken: [],
    patientDetails: {},
    msgAdharmobile: {},
    mobileNumber: {},
    UUid: {},
    resentCount: 3,
    globalCurrentStep: "LoginMobileOTPSend",
  },
  reducers: {
    setGetTime: (state, action) => {
      state.gettime = action.payload;
    },
    setGetAccessToken: (state, action) => {
      state.getaccesstoken = action.payload;
    },
    setPatientDetails: (state, action) => {
      state.patientDetails = action.payload;
    },
    setMobileNumber: (state, action) => {
      state.mobileNumber = action.payload;
    },
    setUuid: (state, action) => {
      state.UUid = action.payload;
    },
    setAbhaLoader: (state, action) => {
      state.loading = action.payload;
    },
    setAdharMsg: (state, action) => {
      state.msgAdharmobile = action.payload;
    },
    setResentCount: (state, action) => {
      state.resentCount = action.payload;
    },
    setGlobalCurrentStep: (state, action) => {
      state.globalCurrentStep = action.payload;
    },
  },
});

export const {
  setPatientDetails,
  setAbhaLoader,
  setAdharMsg,
  setMobileNumber,
  setUuid,
  setResentCount,
  setGlobalCurrentStep,
} = abhaSlice.actions;

export default abhaSlice.reducer;
